module.exports = __webpack_public_path__ + "static/img/1.ff2d4747.jpg";